import { Box, Stack } from '@mui/material';
import styles from './styles';
import React, { useEffect, useState } from 'react';
import { formatPercent } from 'tools/tools';
import useBundleTranslation from 'i18n';
import showdown from 'showdown';
import { ITileInfoValue } from '../types';
import striptags from 'striptags';

const converter = new showdown.Converter();

export default function InfoValue({ tile }: { tile: ITileInfoValue }) {
    const { t } = useBundleTranslation(['app/home']);
    const [descriptionCut, setDescriptionCut] = useState<boolean>(false);
    const [descriptionExpand, setDescriptionExpand] = useState<boolean>(false);
    const descriptionContentRef = React.useRef<HTMLDivElement>(null);

    const showElementInfo =
        tile.element_info &&
        tile.element_dashboard_name !==
            tile.element_info.replaceAll('<p>', '').replaceAll('</p>', '').replaceAll('\n', '');
    const showComparison = tile.element_type !== 'multi-metric chart' && tile.last_measurement_value_formatted;

    const description =
        tile.description_markdown_ind === 'Y'
            ? converter.makeHtml(String(tile.element_info))
            : striptags(String(tile.element_info), ['br', 'b', 'a', 'i']);

    const maxDescContainerHeight = 176; //11 rows (1row = 16px)

    useEffect(() => {
        if (descriptionContentRef.current) {
            setDescriptionCut(descriptionContentRef.current.clientHeight > maxDescContainerHeight);
        }
    }, []);

    return showElementInfo || showComparison ? (
        <Stack direction="row" sx={styles.sectionWrapper}>
            <Box sx={styles.iconHolder} />
            <Stack direction={'column'} spacing={1} sx={{ width: 1, overflow: 'hidden' }}>
                {showComparison && tile.metric_tile_display_pct_variance && (
                    <Box fontWeight={600}>{`${tile.last_measurement_value_formatted} ${
                        tile.metric_tile_display_pct_variance > 0
                            ? t('info_panel.up')
                            : tile.metric_tile_display_pct_variance < 0
                              ? t('info_panel.down')
                              : ''
                    } ${formatPercent(String(Math.abs(tile.metric_tile_display_pct_variance)))} ${
                        tile.pct_variance_text === 'from last day'
                            ? t('info_panel.from_yesterday')
                            : tile.pct_variance_text
                    }`}</Box>
                )}
                {showElementInfo && (
                    <>
                        <Box
                            sx={{
                                ...styles.descriptionHolder,
                                maxHeight:
                                    descriptionCut && !descriptionExpand ? `${maxDescContainerHeight}px` : 'none',
                            }}
                        >
                            <Box
                                ref={descriptionContentRef}
                                sx={styles.descriptionItem}
                                className={'markdown-holder'}
                                dangerouslySetInnerHTML={{
                                    __html: description,
                                }}
                            />
                        </Box>
                        {descriptionCut && (
                            <Box
                                onClick={() => {
                                    setDescriptionExpand(!descriptionExpand);
                                }}
                                sx={styles.descriptionExpandControl}
                            >
                                {descriptionExpand ? t('description_show_less') : t('description_show_more')}
                            </Box>
                        )}
                    </>
                )}
            </Stack>
        </Stack>
    ) : null;
}
